"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ListboxItem: true
};
exports.default = exports.ListboxItem = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _Icon = require("../Icon/Icon");
var _isFunction = require("../utils/isFunction");
var _Tooltip = require("../Tooltip/Tooltip");
var _ListContext = require("./_ListContext");
var _ListboxItem = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./ListboxItem.css") : void 0);
var _ListboxItem2 = require("./_ListboxItem.types");
Object.keys(_ListboxItem2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListboxItem2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListboxItem2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-listbox-item';
const ListboxItem = exports.ListboxItem = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      children,
      className,
      disabled,
      divider,
      isActive,
      isSelected,
      canClear,
      clearIconButtonTooltipMsg,
      onClear,
      clearingInstructionKeyboard,
      itemContentProps,
      itemSelectorProps,
      itemSelectorIconProps,
      itemWrapperProps,
      onClick,
      selectorPosition,
      topAlign
    } = props,
    otherProps = __rest(props, ["children", "className", "disabled", "divider", "isActive", "isSelected", "canClear", "clearIconButtonTooltipMsg", "onClear", "clearingInstructionKeyboard", "itemContentProps", "itemSelectorProps", "itemSelectorIconProps", "itemWrapperProps", "onClick", "selectorPosition", "topAlign"]);
  const classnames = _bind.default.bind(_ListboxItem.default);
  const listContextValue = (0, _react.useContext)(_ListContext.ListContext);
  const {
    bordered,
    selectionType,
    gridItemClassName,
    gridItemSelectorClassName,
    selectedGridItemClassName,
    activeGridItemClassName,
    disabledGridItemClassName,
    gridItemWrapperClassName,
    orientation,
    disabled: contextDisabled
  } = listContextValue || {};
  const isDisabled = disabled || contextDisabled;
  const liRef = (0, _react.useRef)();
  const mergedRef = (0, _reactMergeRefs.default)([ref, liRef]);
  const classes = classnames(CSS_BLOCK, className, gridItemClassName, Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    [`${CSS_BLOCK}--active`]: isActive
  }, activeGridItemClassName && {
    [activeGridItemClassName]: isActive
  }), {
    [`${CSS_BLOCK}--bordered`]: bordered,
    [`${CSS_BLOCK}--selected`]: isSelected
  }), selectedGridItemClassName && {
    [selectedGridItemClassName]: isSelected
  }), {
    [`${CSS_BLOCK}--disabled`]: disabled && !contextDisabled,
    [`${CSS_BLOCK}--all-disabled`]: contextDisabled
  }), disabledGridItemClassName && {
    [disabledGridItemClassName]: isDisabled
  }), {
    [`${CSS_BLOCK}--horizontal`]: orientation === 'horizontal'
  }));
  if (divider) {
    return /*#__PURE__*/_react.default.createElement("li", Object.assign({}, otherProps, {
      className: classnames(className, CSS_BLOCK, `${CSS_BLOCK}__divider`, {
        [`${CSS_BLOCK}__divider--${orientation}`]: orientation !== 'vertical'
      }),
      ref: ref,
      role: "separator",
      "aria-hidden": true
    }));
  }
  const handleClick = event => {
    const targetTestId = event.target.getAttribute('data-testid');
    const isClearButton = targetTestId === 'listbox-item-clear';
    if (isClearButton) {
      onClear === null || onClear === void 0 ? void 0 : onClear();
      return;
    }
    if ((0, _isFunction.isFunction)(onClick) && !isDisabled) {
      onClick(event, liRef === null || liRef === void 0 ? void 0 : liRef.current, !!isSelected);
    }
  };
  const renderChildren = () => {
    const wrapperClasses = classnames(`${CSS_BLOCK}__wrapper`, itemWrapperProps === null || itemWrapperProps === void 0 ? void 0 : itemWrapperProps.className, gridItemWrapperClassName, {
      [`${CSS_BLOCK}__wrapper--${selectorPosition}`]: (selectorPosition === null || selectorPosition === void 0 ? void 0 : selectorPosition.trim()) && selectionType !== 'singleSelectMaster',
      [`${CSS_BLOCK}__wrapper--with-clear`]: canClear
    });
    const selectorClasses = classnames(`${CSS_BLOCK}__selector`, itemSelectorProps === null || itemSelectorProps === void 0 ? void 0 : itemSelectorProps.className, gridItemSelectorClassName, {
      [`${CSS_BLOCK}__selector--topalign`]: topAlign
    });
    const contentClasses = classnames(`${CSS_BLOCK}__content`, itemContentProps === null || itemContentProps === void 0 ? void 0 : itemContentProps.className);
    let iconName = '';
    if (selectionType === 'singleSelectLeft') {
      iconName = isSelected ? 'radiogroup-selected' : 'radiogroup';
    } else if (selectionType === 'multiSelect') {
      iconName = isSelected ? 'checkbox-selected' : 'checkbox';
    }
    const clearIcon = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: `${CSS_BLOCK}__screen-reader-only`
    }, clearingInstructionKeyboard), /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
      "aria-hidden": true,
      placement: ['top', 'bottom'],
      message: clearIconButtonTooltipMsg,
      doNotDescribe: true
    }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
      ariaHidden: true,
      iconName: "close",
      "data-testid": "listbox-item-clear",
      tabIndex: -1,
      forceSize: "xs",
      className: classnames(`${CSS_BLOCK}__clear-icon`)
    })));
    if (selectionType === 'singleSelectMaster') {
      return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, itemWrapperProps, {
        className: wrapperClasses
      }), children, canClear ? clearIcon : null);
    }
    return /*#__PURE__*/_react.default.createElement("div", Object.assign({}, itemWrapperProps, {
      className: wrapperClasses
    }), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, itemSelectorProps, {
      className: selectorClasses
    }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({}, itemSelectorIconProps, {
      ariaHidden: true,
      iconName: iconName
    }))), /*#__PURE__*/_react.default.createElement("div", Object.assign({}, itemContentProps, {
      className: contentClasses
    }), children), canClear ? clearIcon : null);
  };
  const ariaSelected = isSelected ? 'true' : 'false';
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    _react.default.createElement("li", Object.assign({}, otherProps, {
      "aria-selected": ariaSelected,
      "aria-disabled": isDisabled,
      className: classes,
      ref: mergedRef,
      role: "option",
      onClick: handleClick
    }), renderChildren())
  );
});
ListboxItem.displayName = 'Listbox.Item';
var _default = exports.default = ListboxItem;